import { useEffect, useState } from "react";
import axios from "axios";
import { SiteNav, SiteFooter } from "../components/SiteChrome";
import "../styles/site.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Stats() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    document.title = "C-STYL — Visitor Stats";
    window.scrollTo(0, 0);
    axios
      .get(`${API}/stats`)
      .then((r) => setData(r.data))
      .catch(() => setError(true));
  }, []);

  return (
    <div className="site" data-testid="stats-page">
      <SiteNav />
      <div className="doc">
        <h1 className="serif">Visitor Stats</h1>
        <p style={{ color: "#8b857c" }}>Live traffic for c-styl.com</p>

        {error && <p data-testid="stats-error">Could not load stats right now.</p>}

        {data && (
          <>
            <div className="grid-cards" data-testid="stats-cards">
              <div className="card">
                <h3 style={{ fontSize: 34, color: "#C8A24C" }} data-testid="stat-total-views">{data.total_page_views}</h3>
                <p>Total page views</p>
              </div>
              <div className="card">
                <h3 style={{ fontSize: 34, color: "#C8A24C" }} data-testid="stat-unique">{data.unique_visitors}</h3>
                <p>Unique visitors</p>
              </div>
              <div className="card">
                <h3 style={{ fontSize: 34, color: "#C8A24C" }} data-testid="stat-appstore">{data.appstore_clicks}</h3>
                <p>App Store badge taps</p>
              </div>
              <div className="card">
                <h3 style={{ fontSize: 34, color: "#C8A24C" }} data-testid="stat-today">{data.views_today}</h3>
                <p>Page views today</p>
              </div>
              <div className="card">
                <h3 style={{ fontSize: 34, color: "#C8A24C" }} data-testid="stat-looks">{data.looks_generated ?? 0}</h3>
                <p>AI looks generated</p>
              </div>
              <div className="card">
                <h3 style={{ fontSize: 34, color: "#C8A24C" }} data-testid="stat-looks-today">{data.looks_today ?? 0}</h3>
                <p>AI looks today</p>
              </div>
            </div>

            <h2>Views by page</h2>
            <ul data-testid="stats-by-path">
              {Object.entries(data.views_by_path).map(([path, count]) => (
                <li key={path}><b>{count}</b> — {path}</li>
              ))}
            </ul>
          </>
        )}
      </div>
      <SiteFooter />
    </div>
  );
}
